import { checkTrackingConversion } from './helpers/util';

export async function handleGTMTracking(gtmTracking, globalConversionSetting, conversionScope) {
  for (const gtm of gtmTracking) {
    const shouldProcess = await checkTrackingConversion(
      gtm,
      `GTMTracking_${gtm.pixelId}`,
      globalConversionSetting,
      conversionScope
    );
    if (!shouldProcess) continue;

    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'formLocation': 'head','gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm.pixelId}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtm.pixelId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }
}
